import React, { useEffect, useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import SealReportViewer from './SealReportViewer';
import { getReportDefinitions } from '../../../api/reportsApi';
import { useI18n } from '../../../i18n';
import { splitBySection } from '../reportSections';

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`reports-tabpanel-${index}`}
    aria-labelledby={`reports-tab-${index}`}
    {...other}
  >
    {value === index && <Box>{children}</Box>}
  </div>
);

const ReportsContainer = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState(0);
  const [sections, setSections] = useState({ reports: [], audit: [] });
  const [isLoadingReports, setIsLoadingReports] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoadingReports(true);
    setLoadError(null);

    getReportDefinitions({
      pageNumber: 1,
      pageSize: 100,
      sortField: 'reportTitle',
      sortOrder: 'Ascending',
    })
      .then((data) => {
        if (!cancelled) setSections(splitBySection(data));
      })
      .catch(() => {
        if (!cancelled) setLoadError(t('reports.loadFailed'));
      })
      .finally(() => {
        if (!cancelled) setIsLoadingReports(false);
      });

    return () => {
      cancelled = true;
    };
  }, [t]);

  const handleTabChange = (_event, newValue) => {
    setActiveTab(newValue);
  };

  // The backend lists audit reports only to full-access roles, so the tab
  // appears exactly for the users SEAL lets run them.
  const showAudit = sections.audit.length > 0;

  return (
    <Box sx={{ marginTop: 3, marginBottom: 3 }}>
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label={t('reports.tabsLabel')}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            label={t('reports.viewTab')}
            id="reports-tab-0"
            aria-controls="reports-tabpanel-0"
          />
          {showAudit && (
            <Tab
              label={t('reports.auditTab')}
              id="reports-tab-1"
              aria-controls="reports-tabpanel-1"
            />
          )}
        </Tabs>

        <TabPanel value={activeTab} index={0}>
          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <SealReportViewer
              reports={sections.reports}
              isLoadingReports={isLoadingReports}
              loadError={loadError}
            />
          </Box>
        </TabPanel>
        {showAudit && (
          <TabPanel value={activeTab} index={1}>
            <Box sx={{ p: { xs: 2, md: 3 } }}>
              <SealReportViewer
                reports={sections.audit}
                isLoadingReports={isLoadingReports}
                loadError={loadError}
              />
            </Box>
          </TabPanel>
        )}
      </Paper>
    </Box>
  );
};

export default ReportsContainer;
